import React from 'react';

import { useAppSelector } from '@core/hooks/appHooks';
import { selectFirestoreUser } from '@core/store/userSlice/userSlice';

import CustomerAddress from './partials/CustomerAddress';
import CustomerDetails from './partials/CustomerDetails';

const YourAccount: React.FC = () => {
  const CSSBlock = 'your-account';
  const customer = useAppSelector(selectFirestoreUser);

  return (
    <div className={CSSBlock}>
      <div className={`${CSSBlock}__title`}>Manage Your Account</div>
      {customer && <CustomerDetails customer={customer} />}
      {customer && <CustomerAddress customer={customer} />}
    </div>
  );
};

export default YourAccount;
